import { render, staticRenderFns } from "./AddStoragePosition.vue?vue&type=template&id=6afb04d8"
import script from "./AddStoragePosition.vue?vue&type=script&lang=js"
export * from "./AddStoragePosition.vue?vue&type=script&lang=js"
import style0 from "./AddStoragePosition.vue?vue&type=style&index=0&id=6afb04d8&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports